export default __webpack_public_path__ + "static/media/small_logo.77552a54.svg";